import '@shopify/polaris/build/esm/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'
import CardWithAllElements from './Settings';
import App from './App'
import { AppProvider } from '@shopify/polaris';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);